<template>
 <div class="carrusel-container-personajes">
  <div class="container">
    <div class="row">
      <div class="col-12 mb-5">
        <h2 class="text-center carousel-title">Desinformación en acción</h2>
      </div>
      <div class="col-12">
        <VueSlickCarousel v-bind="settings" :arrows="true" :dots="true">
          <div :key="ix" v-for="(img, ix) in images" class="active carousel-item">
            <div class="cloud-message" :class="{'turn': img.turn == true}" v-html="img.title"></div>
            <img
              :src="`/wp-content/interactivos/el-cartel-de-la-desinformacion/${img.src}`"
              class="img-carrusel"
              blank="true"
            >
          </div>
        </VueSlickCarousel>

      </div>
    </div>
  </div>
 </div>
</template>

<style>

  .carousel-title {
    font-size: 31px;
    color: #fff;
    font-family: "Fira Sans",sans-serif;
  }

  .carrusel-container-personajes {
    background-color: #000;
    background-image: url('../assets/net-img-h.png');
    background-repeat: no-repeat;
    background-size: cover;
    padding: 45px 0;
    width: 100%;
    overflow: hidden;
  }

  .carousel-item {
    padding: 0 0;
  }

  .slick-prev {
    left: 0;
    z-index: 99;
  }
  
  .slick-next {
    right: 0;
    z-index: 99;
  }

  .slick-dots li button {
    font-size: 0;
    line-height: 0;
    display: block;
    width: 20px;
    height: 20px;
    padding: 5px;
    cursor: pointer;
    color: transparent;
    border: 0;
    outline: none;
    background: transparent;
  }

  .slick-dots li button:before {
    font-family: 'slick';
    font-size: 25px;
    line-height: 20px;
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    content: '•';
    text-align: center;
    opacity: 0.25;
    color: white;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .slick-dots li.slick-active button:before {
    opacity: 1;
    color: #929292;
  }

  .slick-dots li button:before {
    font-family: 'slick';
    font-size: 25px;
    line-height: 20px;
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    content: '•';
    text-align: center;
    opacity: 1;
    color: white;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .slick-prev:before, .slick-next:before {
    font-family: 'slick';
    font-size: 45px;
    line-height: 1;
    opacity: 0.75;
    color: #fff;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .cloud-message {
    width: 100%;
    max-width: 320px;
    margin: 35px auto 0 auto;
    background-color: #fff;
    padding: 10px;
    font-size: 16px;
    border-radius: 5px;
    transform: rotate(5deg);
    font-family: "Noto Sans";
    box-shadow: 0px 0px 4px 2px #919191;
    
    &.turn {
      transform: rotate(-5deg);
    }
  }

  .img-carrusel {
    width: 100%;
    max-width: 420px;
    margin: 0 auto 0 auto;
    display: block;
    pointer-events: none;
  }

  .carousel-intro {
    font-weight: bold;
  }



</style>

<script>

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'


export default {
  name: 'Carousel',
  components: {
    VueSlickCarousel
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log('slide change');
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
  data() {
	return {
      settings: {
        "dots": true,
        "focusOnSelect": true,
        "infinite": true,
        "speed": 500,
        "slidesToShow": 2,
        "slidesToScroll": 2,
        "touchThreshold": 6,
        "responsive": [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 320,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
      ],
      },
      images: [
        {
          src: 'carrusel/01.png',
          alt: 'Image 2',
          turn: false,
          title: '<strong class="carousel-intro">ALIADOS</strong>. Erasmo Wong y Raúl Diez Canseco –propietarios de <i>Willax</i> y USIL, respectivamente–, firmaron un acuerdo para crear un podcast llamado “Consejo Económico” a cargo de el presentador de <i>Willax</i> y <i>PBO</i>, YouTuber y asesor de comunicaciones de la USIL, Augusto Thorndike.'
        },
        {
          src: 'carrusel/02.png',
          alt: 'Image 2',
          turn: true,
          title: '<strong class="carousel-intro">ATAQUE</strong>. El diario <i>Expreso</i> es parte de una insistente campaña que lleva casi una década en contra de la periodista Paola Ugaz, quien viene investigando al Sodalicio de Vida Cristiana, sus víctimas y sus finanzas.'
        },
        {
          src: 'carrusel/03.png',
          alt: 'Image 2',
          turn: false,
          title: '<strong class="carousel-intro">EXTREMISMO.</strong> Además de promover contenidos ultraconservadores, recientemente <i>ILAD Media</i> incorporó como comentarista a Gonzalo Serpa, quien antes dijo de la comunidad LGTB que “agarraría una ametralladora y me los barrería a todos esos hijos de la gran puta”.'
        },
        {
          src: 'carrusel/04.png',
          alt: 'Image 2',
          turn: true,
          title: '<strong class="carousel-intro">ADOCTRINAMIENTO EN USIL.</strong> La Universidad San Ignacio de Loyola tiene convenios con <i>Expreso</i>, <i>Willax</i> y acoge clases de la escuela Prolíderes de ILAD a cargo del controversial agitador de ultraderecha Miklos Lukacs.'
        }, {
          src: 'carrusel/05.png',
          alt: 'Image 2',
          turn: false,
          title: '<strong class="carousel-intro">COMUNIDAD DESINFORMANTE.</strong> En varias comunidades ligadas a <i>El Reporte</i> se alimenta contenido conservador violentista y de <i>fake news.</i> Su director, Santiago Carranza, es hijo de la congresista Patricia Chirinos.'
        },{
          src: 'carrusel/06.png',
          alt: 'Image 2',
          turn: true,
          title: '<strong class="carousel-intro">ENCUENTRO.</strong> En el foro de ILAD de agosto de 2024 se dieron cita diversos líderes de la derecha como Giuliana Caccia –recientemente amenazada con excomunión por el Papa– junto al director de <i>Piensa.pe</i> José Ignacio Beteta (cuyo medio invirtió en la campaña por Keiko Fujimori), y el congresista José Cueto.'
        }
      ]
    }
  }
};
</script>
